<template>
	<article class="teaser teaser-team">
		<div class="teaser-team__inner">
			<div
				class="teaser-team__cover"
				:class="{ 'teaser-team__cover-no-image': !imageSizes.length }"
			>
				<picture v-if="imageSrcSet" class="teaser-team__image">
					<source :srcset="imageSrcSet" />
					<img :src="imageSizes[0]" :alt="`Foto ${title}`" />
				</picture>
				<picture v-else class="teaser-team__image">
					<img :src="fallbackImage()" alt="" />
				</picture>
			</div>
			<div class="teaser-team__body">
				<h3 class="teaser-team__title">{{ title }}</h3>
				<div class="teaser-team__function">{{ jobFunction }}</div>
				<div class="teaser-team__actions">
					<div v-if="phoneNumber" class="teaser-team__phone">
						<a :href="`tel:${phoneNumber}`"
							><Icon name="phone" />{{ phoneNumber }}</a
						>
					</div>
					<a
						v-if="email"
						:href="`mailto:${email}`"
						class="teaser-team__btn btn btn--b"
						>Mail mij</a
					>
				</div>
				<div class="teaser-team__social-links">
					<a
						v-if="whatsapp"
						target="_blank"
						class="teaser-team__social-links-link"
						:href="`https://wa.me/${whatsapp}`"
					>
						<Icon name="whatsapp" />
						<span class="visually-hidden">Stuur whatsapp bericht</span>
					</a>
					<a
						v-if="linkedin"
						target="_blank"
						class="teaser-team__social-links-link"
						:href="linkedin"
					>
						<Icon name="linkedin" />
						<span class="visually-hidden">Bezoek Linkedin profiel</span>
					</a>
				</div>
			</div>
		</div>
	</article>
</template>
<script>
import { store } from "./store.js";
import Icon from "./Icon.vue";
export default {
	name: "TeamTeaser",
	props: [
		"title",
		"jobFunction",
		"email",
		"phoneNumber",
		"whatsapp",
		"linkedin",
		"imageSizes",
	],
	data() {
		return {
			imageSrcSet: null,
			store,
		};
	},
	components: {
		Icon,
	},
	mounted: function () {
		if (this.imageSizes) {
			this.imageSrcSet = this.imageSizes
				.map((src, index) => {
					if (index == 0) {
						return `${src} 1x`;
					} else if (index === 1) {
						return `, ${src} 2x`;
					}
				})
				.join(" ");
		}
	},
	methods: {
		fallbackImage() {
			return `${window.THEME_LINK}/${store.teamTeaserFallbackImage}`;
		},
	},
};
</script>
